import * as React from "react";
import classnames from "classnames";

import styles from "./styles.module.scss";

export interface IconButtonProps {
  start?: boolean;
  className?: string;
  icon: React.ReactNode;
  dataTestId?: string;
  onClick?(e: React.MouseEvent<HTMLButtonElement>): void;
  type?: "button" | "submit" | "reset";
}

function IconButton({
  icon,
  onClick,
  start = false,
  className,
  dataTestId,
  type = "button",
}: IconButtonProps) {
  return (
    <button
      type={type}
      tabIndex={0}
      className={classnames(styles.icon, className, {
        [styles.start]: start,
      })}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {icon}
    </button>
  );
}

export default IconButton;
